import { useNavigate } from 'react-router-dom';
import { useRecoilCallback } from 'recoil';

import { useOAuthLogoutMutation } from '../../../Auth/api/oauth';
import { logout as clearAuthSlice } from '../../../domains/Auth/slice';
import { clearCheckoutSlice } from '../../../domains/Checkout/slice';
import { hideTermsPrompt } from '../../../domains/UI/store/slice';
import { deleteLocalInfo } from '../../../MedianFunctions';
import { useAppDispatch, useAppSelector } from '../../../reduxstore/hooks';
import { deleteAccessToken } from '../../../utils/userStorage';
import { profileIdState } from '../../atoms';
import { namedOperations, useLogoutMutation } from '../../graphql';
import { logout as clearProfileSlice } from '../../state/profileSlice';

export const useLogout = (): (() => void) => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const [OAuthLogout] = useOAuthLogoutMutation();

	const { accessToken } = useAppSelector(state => state.authReducer);
	const onDeleteToken = () => {
		deleteAccessToken();
	};

	const medianIsLoaded = navigator.userAgent.indexOf('median') > -1;

	const onCompleted = useRecoilCallback(
		({ reset }) =>
			() => {
				try {
					onDeleteToken();
					OAuthLogout({
						headers: {
							authorization: `Bearer ${accessToken}`
						}
					});
					dispatch(clearProfileSlice());
					dispatch(clearAuthSlice());
				} catch {
					// console.log(err);
				}

				if (medianIsLoaded) {
					deleteLocalInfo();
				}
				localStorage.removeItem('recoil-persist');
				reset(profileIdState);
				dispatch(hideTermsPrompt());
				dispatch(clearCheckoutSlice());
				navigate('/');
			},
		[navigate, dispatch, OAuthLogout, accessToken, medianIsLoaded]
	);

	const [logoutMutation] = useLogoutMutation({
		onCompleted: onCompleted,
		onError(err) {
			console.error(err);
		},
		refetchQueries: [
			namedOperations.Query.Authenticated,
			namedOperations.Query.Account,
			namedOperations.Query.Cards
		]
	});

	return logoutMutation;
};
